export const accordion1 = `<Accordion defaultActiveKey="0">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion2 = `  <Accordion defaultActiveKey={['0']} alwaysOpen>
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion3 = `<Accordion defaultActiveKey="0" flush>
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body>Placeholder content for this accordion,
      which isintended to demonstrate the <code>.accordion-flush</code> class.
      This is the first item's accordion body.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body>which is intended to demonstrate the <code>.accordion-flush</code> class.
      This is thesecond item's accordion body. Let's imagine this being filled
      with some actual content.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body>Placeholder content for this accordion,
      which is intended to demonstrate the <code>.accordion-flush</code> class.
      This is the third item's accordion body. Nothing more exciting happening
      here in  terms of content, but just filling up the space to make it look, at
      least at first glance, a bit more representative of how this would look in a
      real-world application.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion4 = `<Accordion defaultActiveKey="0" className="accordion accordion-primary">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion5 = `<Accordion defaultActiveKey="0" className="accordion accordion-secondary">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion6 = `<Accordion defaultActiveKey="0" className="accordion accordion-solid-primary">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion7 = `  <Accordion defaultActiveKey="0" className="accordion accordion-solid-secondary">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion8 = ` <Accordion defaultActiveKey="0" className="accordion accordion-border-primary accordions-items-seperate">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`
export const accordion9 = ` <Accordion defaultActiveKey="0" className="accordion accordion-border-success accordions-items-seperate">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion10 = ` <Accordion defaultActiveKey="0" className="accordion accordionicon-left accordions-items-seperate">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion11 = `<Accordion defaultActiveKey="0" className="accordion accordionicon-none accordions-items-seperate">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion12 = `<Accordion defaultActiveKey="0" className="accordion accordion-customicon1 accordions-items-seperate">
  <Accordion.Item eventKey="0">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion13 = ` <Accordion defaultActiveKey="0" className="accordion customized-accordion accordions-items-seperate">
  <Accordion.Item eventKey="0" className="custom-accordion-primary">
    <Accordion.Header>Accordion Item #1</Accordion.Header>
    <Accordion.Body> <strong>This is the first item's accordion body.</strong> It is shown by
      default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just  about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1" className="accordion-item custom-accordion-secondary">
    <Accordion.Header>Accordion Item #2</Accordion.Header>
    <Accordion.Body><strong>This is the second item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about any HTML can go within the <code>.accordion-body</code>, though the
      transition does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2" className="accordion-item custom-accordion-danger">
    <Accordion.Header>Accordion Item #3</Accordion.Header>
    <Accordion.Body><strong>This is the third item's accordion body.</strong> It is hidden
      by default, until the collapse plugin adds the appropriate classes that we
      use to style each element. These classes control the overall appearance, as
      well as the showing and hiding via CSS transitions. You can modify any of this with
      custom CSS or overriding our default variables. It's also worth noting that
      just about  any HTML can go within the <code>.accordion-body</code>, though the
      transition  does limit overflow.
    </Accordion.Body>
  </Accordion.Item>
</Accordion>`

export const accordion14 = `const Accordionscollapse = () => {
  const [openb, setOpenb] = useState(false);
  return (
    <Fragment>
      <p className="mb-0">
        <Button onClick={() => setOpenb(!openb)} aria-controls="example-collapse-text"
          aria-expanded={openb}
          href="#collapseExample" className="btn btn-primary collapsed mb-2 me-1"
            role="button">
          Link with href</Button>
        <Button onClick={() => setOpenb(!openb)} aria-controls="example-collapse-text"
         aria-expanded={openb}
          variant='' className="btn btn-secondary collapsed mb-2" type="button">
          Button with data-bs-target</Button>
      </p>
      <Collapse in={openb}>
        <div className="card card-body mb-0">
          Some placeholder content for the collapse component. This panel
          is
          hidden by default but revealed when the user activates the
          relevant
          trigger.
        </div>
      </Collapse>
    </Fragment>
  );
};
export default Accordionscollapse;`

export const accordion15 = `const Accordionscollapse = () => {
  const [isFirstCollapsed, setisFirstCollapsed] = useState(false);
  const [isSecondCollapsed, setisSecondCollapsed] = useState(false);

  const first = () => {
    if (isFirstCollapsed === false) {
      setisFirstCollapsed(true);
    }
    else if (isFirstCollapsed === true) {
      setisFirstCollapsed(false);
    }
  };

  const second = () => {

    if (isSecondCollapsed === true) {
      setisSecondCollapsed(false);
    }
    else if (isSecondCollapsed === false) {
      setisSecondCollapsed(true);
    }
  };

  const both = () => {
    if (isSecondCollapsed === true) {
      setisSecondCollapsed(false);
    }
    else if (isSecondCollapsed === false) {
      setisSecondCollapsed(true);
    }
    if (isFirstCollapsed === true) {
      setisFirstCollapsed(false);
    }
    else if (isFirstCollapsed === false) {
      setisFirstCollapsed(true);
    }
  };

  return (
    <Fragment>
       <p className="mb-0">
  <Button className="btn btn-primary mb-2 me-1" onClick={() => { first(); }}>
     Toggle first element
  </Button>
  <Button variant='' className="btn btn-success mb-2 me-1" type="button" onClick={() => { second(); }}>
    Toggle second element
  </Button>
  <Button variant='' className="btn btn-danger mb-2" type="button" onClick={() => { both(); }}>
      Toggle both elements
  </Button>
</p>
<Row>
  <div className="col m-1">
    {isFirstCollapsed ? (
      <div className=" multi-collapse" id="multiCollapseExample1">
        <div className="card card-body mb-0">
          Some placeholder content for the first collapse
          component of
          this multi-collapse example. This panel is hidden by
          default
          but revealed when the user activates the relevant
          trigger.
        </div>
      </div>
    ) : null}
  </div>
  <div className="col m-1">
    {isSecondCollapsed ? (
      <div className=" multi-collapse" id="multiCollapseExample2">
        <div className="card card-body mb-0">
          Some placeholder content for the second collapse
          component
          of this multi-collapse example. This panel is hidden by
          default but revealed when the user activates the
          relevant
          trigger.
        </div>
      </div>
    ) : null}
  </div>
</Row>
    </Fragment>
  );
};
export default Accordionscollapse;`

export const accordion16 = `const Accordionscollapse = () => {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
       <p>
         <Button onClick={() => setOpen(!open)} aria-controls="example-collapse-text" 
          aria-expanded={open}>
             Toggle width collapse
         </Button>
       </p>
       <div style={{ minHeight: '120px' }}>
         <Collapse in={open} dimension="width">
           <div id="example-collapse-text">
            <Card body style={{ width: '230px' }}>
              This is some placeholder content for a horizontal collapse. It's
              hidden by default and shown when triggered.
            </Card>
           </div>
         </Collapse>
       </div>
    </Fragment>
  );
};
export default Accordionscollapse;`


export const carosel1 = `<Carousel id="carouselExampleSlidesOnly" 
  className="carousel slide carousel-icons" indicators={false}>
    <Carousel.Item className="active">
        <img src={media26} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item>
        <img src={media27} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item>
        <img src={media33} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
</Carousel>`

export const carosel2 = `<Carousel id="carouselExampleControls" 
   className="carousel slide" data-bs-ride="carousel"
   indicators={false}>
    <Carousel.Item className="active">
        <img src={media28} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item >
        <img src={media31} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item >
        <img src={media32} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
</Carousel>`

export const carosel3 = `<Carousel id="carouselExampleIndicators" 
  className="carousel slide" data-bs-ride="carousel">
    <Carousel.Item className="active">
        <img src={media25} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item>
        <img src={media29} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item>
        <img src={media30} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
</Carousel>`

export const carosel4 = `<Carousel id="carouselExampleCaptions"
   className="carousel slide" data-bs-ride="carousel">
    <Carousel.Item className="active">
        <img src={media59} className="d-block w-100"
         alt="..." />
        <Carousel.Caption className="d-none d-md-block">
            <h5 className='text-fixed-white'>
               First slide label
            </h5>
            <p>
              Some representative placeholder content
              for the first slide.
            </p>
        </Carousel.Caption>
    </Carousel.Item>
    <Carousel.Item>
        <img src={media60} className="d-block w-100"
         alt="..." />
        <Carousel.Caption className="d-none d-md-block">
            <h5 className='text-fixed-white'>
              Second slide label
            </h5>
            <p>
              Some representative placeholder
              content for the second slide.
            </p>
        </Carousel.Caption>
    </Carousel.Item>
    <Carousel.Item>
        <img src={media61} className="d-block w-100"
          alt="..." />
        <Carousel.Caption className="d-none d-md-block">
            <h5 className='text-fixed-white'>
              Third slide label
            </h5>
            <p>
              Some representative placeholder 
              content for the third slide.
            </p>
        </Carousel.Caption>
    </Carousel.Item>
</Carousel>`

export const carosel5 = ` <Carousel fade id="carouselExampleFade"
   className="carousel slide carousel-fade" indicators={false}>
    <Carousel.Item className="active">
        <img src={media43} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item>
        <img src={media44} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item>
        <img src={media45} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
</Carousel>`

export const carosel6 = `<Carousel id="carouselExampleInterval" 
 className="carousel slide" data-bs-ride="carousel"
 indicators={false}>
    <Carousel.Item interval={1000} className="active" >
        <img src={media40} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item interval={2000}>
        <img src={media41} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item >
        <img src={media42} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
</Carousel>`

export const carosel7 = `<Carousel touch={false} 
  id="carouselExampleControlsNoTouching" 
  className="carousel slide" data-bs-touch="false"
  indicators={false}
    data-bs-interval="false">
    <Carousel.Item className="carousel-item active">
        <img src={media13} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item>
        <img src={media14} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
    <Carousel.Item>
        <img src={media18} className="d-block w-100"
         alt="..." />
    </Carousel.Item>
</Carousel>`

export const carosel8 = ` <Carousel id="carouselExampleDark"
 className="carousel slide">
    <Carousel.Item className="active" 
     data-bs-interval="10000">
        <img src={media63} className="d-block w-100"
            alt="..." />
        <Carousel.Caption className="d-none d-md-block">
            <h5 className='text-fixed-white'>
               First slide label
            </h5>
            <p className="op-7">
               Some representative placeholder content
              for the first slide.
            </p>
        </Carousel.Caption>
    </Carousel.Item>
    <Carousel.Item data-bs-interval="2000">
        <img src={media64} className="d-block w-100"
            alt="..." />
        <Carousel.Caption className="d-none d-md-block">
            <h5 className='text-fixed-white'>
              Second slide label
            </h5>
            <p className="op-7"> 
              Some representative placeholder content 
              for the second slide.
            </p>
        </Carousel.Caption>
    </Carousel.Item>
    <Carousel.Item>
        <img src={media62} className="d-block w-100"
            alt="..." />
        <Carousel.Caption className="d-none d-md-block">
            <h5 className='text-fixed-white'>
               Third slide label
            </h5>
            <p className="op-7">
              Some representative placeholder content 
              for the third slide.
            </p>
        </Carousel.Caption>
    </Carousel.Item>
</Carousel>`




export const modal1 = `
const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
//
<Button variant="primary" onClick={() => handleModalOpen('demoModal')}>
Launch demo modal
</Button>
<Modal show={modals["demoModal"] || false} onHide={() => handleModalClose('demoModal')}>
<Modal.Header closeButton>
    <Modal.Title as="h6">Modal title</Modal.Title>
</Modal.Header>
<Modal.Body>...</Modal.Body>
<Modal.Footer>
    <Button variant="secondary" onClick={() => handleModalClose('demoModal')}>
        Close
    </Button>
    <Button variant="primary" onClick={() => handleModalClose('demoModal')}>
        Save Changes
    </Button>
</Modal.Footer>
</Modal>`

export const modal2 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
  return (
    <Fragment>
    <Button variant="primary" onClick={() => handleModalOpen('staticModal')}>
                            Launch static backdrop modal
                        </Button>
                        <Modal show={modals["staticModal"] || false} onHide={() => handleModalClose('staticModal')} backdrop="static" keyboard={false}>
                            <Modal.Header closeButton>
                                <Modal.Title as="h6">Modal title</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                I will not close if you click outside me. Don not even try to press
                                escape key.
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => handleModalClose('staticModal')}>
                                    Close
                                </Button>
                                <Button variant="primary">Understood</Button>
                            </Modal.Footer>
                        </Modal>
    </Fragment>
  );
};

export default Modalsclose;`

export const modal3 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};

  return (
    <Fragment>
    <Button variant='primary' type="button" className="btn btn-primary" onClick={() => handleModalOpen('scrollModal')}>
    Scrolling long content
</Button>
<Modal show={modals['scrollModal'] || false} onHide={() => handleModalClose('scrollModal')} keyboard={false}>
    <Modal.Header closeButton>
        <Modal.Title as="h6">Modal title</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.
            Libero
            ipsum quasi, error quibusdam debitis maiores hic eum? Vitae
            nisi
            ipsa maiores fugiat deleniti quis reiciendis veritatis.</p>
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ea
            voluptatibus, ipsam quo est rerum modi quos expedita facere,
            ex
            tempore fuga similique ipsa blanditiis et accusamus
            temporibus
            commodi voluptas! Nobis veniam illo architecto expedita quam
            ratione quaerat omnis. In, recusandae eos! Pariatur,
            deleniti
            quis ad nemo ipsam officia temporibus, doloribus fuga
            asperiores
            ratione distinctio velit alias hic modi praesentium aperiam
            officiis eaque, accusamus aut. Accusantium assumenda,
            commodi
            nulla provident asperiores fugit inventore iste amet aut
            placeat
            consequatur reprehenderit. Ratione tenetur eligendi, quis
            aperiam dolores magni iusto distinctio voluptatibus minus a
            unde
            at! Consequatur voluptatum in eaque obcaecati, impedit
            accusantium ea soluta, excepturi, quasi quia commodi
            blanditiis?
            Qui blanditiis iusto corrupti necessitatibus dolorem fugiat
            consequuntur quod quo veniam? Labore dignissimos reiciendis
            accusamus recusandae est consequuntur iure.</p>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <p>Lorem ipsum dolor sit amet.</p>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => handleModalClose('scrollModal')}>
            Close
        </Button>
        <Button variant="primary">Understood</Button>
    </Modal.Footer>
</Modal>
    </Fragment>
  );
};

export default Modalsclose;`

export const modal4 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
  return (
    <Fragment>
    <Button type="button" className="btn btn-primary" data-bs-toggle="modal" onClick={() => handleModalOpen('verticalcenterModal')}
                            data-bs-target="#exampleModalScrollable2">
                            Vertically centered modal
                        </Button>
                        <Modal centered show={modals['verticalcenterModal'] || false} onHide={() => handleModalClose('verticalcenterModal')} keyboard={false} className="modal fade">
                            <Modal.Header closeButton>
                                <Modal.Title as="h6">Modal title</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                    Libero ipsum quasi, error quibusdam debitis maiores hic eum? Vitae
                                    nisi ipsa maiores fugiat deleniti quis reiciendis veritatis.</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => handleModalClose('verticalcenterModal')}>
                                    Close
                                </Button>
                                <Button variant="primary">Understood</Button>
                            </Modal.Footer>
                        </Modal>
    </Fragment>
  );
};

export default Modalsclose;`
export const modal5 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
  return (
    <Fragment>
    <Button variant='primary' type="button" className="btn" onClick={() => handleModalOpen('verticalModal')}>
    Vertically centered scrollable modal
</Button>

<Modal centered show={modals['verticalModal'] || false} onHide={() => handleModalClose('verticalModal')}
    keyboard={false} className="modal fade">
    <Modal.Header closeButton>
        <Modal.Title as="h6">Modal title</Modal.Title>
    </Modal.Header>
    <Modal.Body> <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ea
        voluptatibus, ipsam quo est rerum modi quos expedita facere,
        ex
        tempore fuga similique ipsa blanditiis et accusamus
        temporibus
        commodi voluptas! Nobis veniam illo architecto expedita quam
        ratione quaerat omnis. In, recusandae eos! Pariatur,
        deleniti
        quis ad nemo ipsam officia temporibus, doloribus fuga
        asperiores
        ratione distinctio velit alias hic modi praesentium aperiam
        officiis eaque, accusamus aut. Accusantium assumenda,
        commodi
        nulla provident asperiores fugit inventore iste amet aut
        placeat
        consequatur reprehenderit. Ratione tenetur eligendi, quis
        aperiam dolores magni iusto distinctio voluptatibus minus a
        unde
        at! Consequatur voluptatum in eaque obcaecati, impedit
        accusantium ea soluta, excepturi, quasi quia commodi
        blanditiis?
        Qui blanditiis iusto corrupti necessitatibus dolorem fugiat
        consequuntur quod quo veniam? Labore dignissimos reiciendis
        accusamus recusandae est consequuntur iure.</p>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <p>Lorem ipsum dolor sit amet.</p>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => handleModalClose('verticalModal')}>
            Close
        </Button>
        <Button variant="primary">Understood</Button>
    </Modal.Footer>
</Modal>
    </Fragment>
  );
};

export default Modalsclose;`


export const modal6 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
  return (
    <Fragment>
    <Button variant='primary' type="button" className="" onClick={() => handleModalOpen('tooltipModal')}>
    Launch demo modal
</Button>
<Modal show={modals['tooltipModal'] || false} onHide={() => handleModalClose('tooltipModal')} centered className='popover-modal'>
    <Modal.Header closeButton>
        <Modal.Title as="h6"> Modal title</Modal.Title>
    </Modal.Header>
    <Modal.Body> <h5>Popover in a modal</h5>
        <p> This
            <OverlayTrigger trigger="click"
                placement='right'
                // autoclose='true'
                overlay={
                    <Popover placement='bottom'>
                        <Popover.Header> Popover bottom</Popover.Header>
                        <Popover.Body>
                            Vivamus sagittis lacus vel augue laoreet rutrum faucibus.
                        </Popover.Body>
                    </Popover>
                }>
                <Button variant="secondary" className="me-2 ms-2">button</Button>
            </OverlayTrigger>
            triggers a popover on click.
        </p>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => handleModalClose('tooltipModal')}>
            Close
        </Button>
        <Button variant="primary">
            Save Changes
        </Button>
    </Modal.Footer>
</Modal>
    </Fragment>
  );
};

export default Modalsclose;`

export const modal7 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
  return (
    <Fragment>
    <Button variant='' type="button" className="btn btn-primary" onClick={() => handleModalOpen('gridModal')}>
                            Launch demo modal
                        </Button>
                        <Modal show={modals['gridModal'] || false} onHide={() => handleModalClose('gridModal')} centered>
                            <Modal.Header closeButton>
                                <Modal.Title as="h6"> Modal title</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Container fluid>
                                    <Row>
                                        <Col md={4} className=" bg-light border">.col-md-4</Col>
                                        <Col md={4} className=" ms-auto bg-light border">.col-md-4
                                            .ms-auto</Col>
                                    </Row>
                                    <Row className="row mt-3">
                                        <Col md={3} className=" ms-auto bg-light border">.col-md-3
                                            .ms-auto</Col>
                                        <Col md={2} className=" ms-auto bg-light border">.col-md-2
                                            .ms-auto</Col>
                                    </Row>
                                    <Row className="row mt-3">
                                        <Col md={6} className=" ms-auto bg-light border">.col-md-6
                                            .ms-auto</Col>
                                    </Row>
                                    <Row className="row mt-3">
                                        <Col sm={9} className=" bg-light border">
                                            Level 1: .col-sm-9
                                            <Row>
                                                <Col sm={6} className="col-8 bg-light border">
                                                    Level 2: .col-8 .col-sm-6
                                                </Col>
                                                <Col sm={6} className="col-4 bg-light border">
                                                    Level 2: .col-4 .col-sm-6
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => handleModalClose('gridModal')}>
                                    Close
                                </Button>
                                <Button variant="primary">
                                    Save Changes
                                </Button>
                            </Modal.Footer>
                        </Modal>
    </Fragment>
  );
};

export default Modalsclose;`

export const modal8 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
  return (
    <Fragment>
    <Button variant='primary' className="btn" onClick={() => handleModalOpen('firstModal')}>Open first modal
    </Button>
    <Modal id="m1" className="fade"
        aria-labelledby="contained-modal-title-vcenter" centered show={modals['firstModal']} onHide={() => handleModalClose('firstModal')} >
        <Modal.Header closeButton>
            <h6 className='modal-title' id="exampleModalToggleLabel">Modal 1</h6>

        </Modal.Header>
        <Modal.Body>
            Show a second modal and hide this one with the button below. </Modal.Body>
        <Modal.Footer>
            <Button className="btn btn-primary" id="btn1" onClick={() => handleModalOpen('secondModal')}>Open second modal</Button>
        </Modal.Footer>

    </Modal>

    <Modal id="m2" className='fade' aria-labelledby="contained-modal-title-vcenter"
        centered show={modals['secondModal']} onHide={() => handleModalClose('secondModal')}>
        <Modal.Header closeButton>
            <Modal.Title as="h6">Modal 2</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Hide this modal and show the first with the button below.</Modal.Body>
        <Modal.Footer>
            <Button className="btn btn-primary"
                onClick={() => handleModalClose('secondModal')}>Back to first</Button>
        </Modal.Footer>

    </Modal>
    </Fragment>
  );
};

export default Modalsclose;`

export const modal9 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
  return (
    <Fragment>
    <Button variant='primary' type="button" className="btn m-1" onClick={() => handleModalOpen('extraLargeModal')}
                            data-bs-target="#exampleModalXl">Extra large modal</Button>
                        <Button variant='primary-light' type="button" className="btn  m-1" onClick={() => handleModalOpen('largeModal')}
                            data-bs-target="#exampleModalLg">Large modal</Button>
                        <Button variant='primary-light' type="button" className="btn  m-1" onClick={() => handleModalOpen('smallModal')}
                            data-bs-target="#exampleModalSm">Small modal</Button>
                        <Modal size="xl" show={modals['extraLargeModal']} onHide={() => handleModalClose('extraLargeModal')}
                            aria-labelledby="example-modal-sizes-title-sm">
                            <Modal.Header closeButton>
                                <Modal.Title as="h6" id="example-modal-sizes-title-sm">
                                    Extra large Modal
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>...</Modal.Body>
                        </Modal>
                        <Modal size="lg" show={modals['largeModal']} onHide={() => handleModalClose('largeModal')} aria-labelledby="example-modal-sizes-title-lg">
                            <Modal.Header closeButton>
                                <Modal.Title as="h6" id="example-modal-sizes-title-lg">
                                    Large Modal
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>...</Modal.Body>
                        </Modal>
                        <Modal size="sm" show={modals['smallModal']} onHide={() => handleModalClose('smallModal')}
                            aria-labelledby="example-modal-sizes-title-sm">
                            <Modal.Header closeButton>
                                <Modal.Title as="h6" id="example-modal-sizes-title-sm">
                                    Small Modal
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>...</Modal.Body>
                        </Modal>
       </Fragment>`

export const modal10 = `const Modalsclose = () => {
    const values = [true, 'sm-down', 'md-down', 'lg-down', 'xl-down', 'xxl-down',];
    const colors = ['primary', 'secondary', 'warning', 'info', 'success', 'danger'];
    const [fullscreen, setFullscreen] = useState(true);
    const [showf, setShowf] = useState(false);

    function handleShowf(breakpoint, _color) {
        setFullscreen(breakpoint);
        setShowf(true);
    }
  return (
    <Fragment>
      {values.map((v, idx) => (
           <Button
               key={idx}
               className={'me-2 mb-2 btn-$#38{colors[idx % colors.length]}'}
               onClick={() => handleShowf(v, colors[idx % colors.length])}
           >
               Full screen {typeof v === 'string' && 'below $#38{v.split('-')[0]}'}
           </Button>
       ))}
       <Modal show={showf} fullscreen={fullscreen} onHide={() => setShowf(false)}>
           <Modal.Header closeButton>
               <Modal.Title as="h6">Full screen {typeof v === 'string' && 'below $#38{v.split('-')[0]}'}</Modal.Title>
           </Modal.Header>
           <Modal.Body>Modal body content</Modal.Body>
           <Modal.Footer>
               <Button variant="secondary" onClick={() => setShowf(false)}>
                   Close
               </Button>
           </Modal.Footer>
       </Modal>
    </Fragment>
  );
};

export default Modalsclose;`

export const modal11 = `    const [modals, setModals] = useState({});
const handleModalOpen = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
};
const handleModalClose = (modalName) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
};
  return (
    <Fragment>
    <Button variant='primary' type="button" className="btn  mb-1 me-2" onClick={() => handleModalOpen('@mdoModal')}>Open modal for
    @mdo</Button>
<Modal show={modals['@mdoModal']} onHide={() => handleModalClose('@mdoModal')}>
    <Modal.Header closeButton>
        <Modal.Title as="h6">New message to @mdo
        </Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Recipient:</Form.Label>
                <Form.Control type="email" placeholder="@mdo" autoFocus />
            </Form.Group>
            <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
            >
                <Form.Label>Message:</Form.Label>
                <Form.Control as="textarea" rows={3} />
            </Form.Group>
        </Form>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => handleModalClose('@mdoModal')}>
            Close
        </Button>
        <Button variant="primary">Send message</Button>
    </Modal.Footer>
</Modal>
<Button variant='secondary' type="button" className="btn mb-1 me-2" onClick={() => handleModalOpen('@fatModal')}>Open modal for
    @fat</Button>
<Modal show={modals['@fatModal'] || false} onHide={() => handleModalClose('@fatModal')}>
    <Modal.Header closeButton>
        <Modal.Title as="h6">New message to @fat
        </Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Recipient:</Form.Label>
                <Form.Control type="email" placeholder="@fat" autoFocus />
            </Form.Group>
            <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
            >
                <Form.Label>Message:</Form.Label>
                <Form.Control as="textarea" rows={3} />
            </Form.Group>
        </Form>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => handleModalClose('@fatModal')}>
            Close
        </Button>
        <Button variant="primary">Send message</Button>
    </Modal.Footer>
</Modal>
<Button variant='light' type="button" className="btn btn-light mb-1" onClick={() => handleModalOpen('@getModal')}>Open modal for
    @getbootstrap</Button>
<Modal show={modals['@getModal'] || false} onHide={() => handleModalClose('@getModal')}>
    <Modal.Header closeButton >
        <Modal.Title as="h6">Modal heading</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Recipient:</Form.Label>
                <Form.Control
                    type="email"
                    placeholder=" @getbootstrap"
                    autoFocus
                />
            </Form.Group>
            <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
            >
                <Form.Label>Message:</Form.Label>
                <Form.Control as="textarea" rows={3} />
            </Form.Group>
        </Form>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => handleModalClose('@getModal')}>
            Close
        </Button>
        <Button variant="primary">Send message</Button>
    </Modal.Footer>
</Modal>
    </Fragment>
  );
};

export default Modalsclose;`

export const modal12 = `const Modalsclose = () => {
    const viewDemoClose1 = (modal) => {
      switch (modal) {
          case "Basic":
              setanimation1(false);
              break;
          case "show2":
              setanimation2(false);
              break;
          case "show3":
              setanimation3(false);
              break;
          case "show4":
              setanimation4(false);
              break;
          case "show5":
              setanimation5(false);
              break;
          case "show6":
              setanimation6(false);
              break;
          case "show7":
              setanimation7(false);
              break;
          case "show8":
              setanimation8(false);
              break;
          case "show9":
              setanimation9(false);
              break;
      }
    };
  return (
    <Fragment>
        <Row className="row-sm">
         <Col sm={6} md={4} xl={3} className="col-sm-6 col-md-4 col-xl-3">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("Basic")}>Zoom</Link>
             <Rodal onClose={hide} visible={animation1} animation='Scale' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("Basic"); }}>
                         <i className='fe fe-x ms-auto'></i>
                     </span>
                     </Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. 
                     The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, 
                     content here', making it look like readable English.
                 </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button className='' variant="secondary" onClick={() => viewDemoClose1("Basic")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
         <Col sm={6} md={4} xl={3} className="mg-t-20 mg-sm-t-0">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("show2")}>Fade</Link>
             <Rodal onClose={hide} visible={animation2} animation='fade' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("show2"); }}><i className='fe fe-x ms-auto'></i></span></Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at 
                     its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to 
                     using 'Content here, content here', making it look like readable English.
                 </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button variant="secondary" onClick={() => viewDemoClose1("show2")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
         <Col sm={6} md={4} xl={3} className="mg-t-20 mg-md-t-0">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("show3")}>Flip</Link>
             <Rodal onClose={hide} visible={animation3} animation='flip' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("show3"); }}><i className='fe fe-x ms-auto'></i></span></Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point 
                     of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', 
                     making it look like readable English.
                </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button variant="secondary" onClick={() => viewDemoClose1("show3")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
         <Col sm={6} md={4} xl={3} className="mg-t-20 mg-xl-t-0">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("show4")}>Door</Link>
             <Rodal onClose={hide} visible={animation4} animation='door' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("show4"); }}><i className='fe fe-x ms-auto'></i></span></Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem 
                     Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like 
                     readable English.
                 </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button variant="secondary" onClick={() => viewDemoClose1("show4")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
         <Col sm={6} md={4} xl={3} className="mg-t-20">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("show5")}>Rotate</Link>
             <Rodal onClose={hide} visible={animation5} animation='rotate' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("show5"); }}><i className='fe fe-x ms-auto'></i></span></Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using 
                     Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like 
                     readable English.
                </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button variant="secondary" onClick={() => viewDemoClose1("show5")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
         <Col sm={6} md={4} xl={3} className="mg-t-20">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("show6")}>Slide-Up</Link>
             <Rodal onClose={hide} visible={animation6} animation='slideUp' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("show6"); }}><i className='fe fe-x ms-auto'></i></span></Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem 
                     Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like 
                     readable English.
                </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button variant="secondary" onClick={() => viewDemoClose1("show6")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
         <Col sm={6} md={4} xl={3} className="mg-t-20">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("show7")}>slide-Down</Link>
             <Rodal onClose={hide} visible={animation7} animation='slideDown' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("show7"); }}><i className='fe fe-x ms-auto'></i></span></Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. 
                     The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, 
                     content here', making it look like readable English.
                 </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button variant="secondary" onClick={() => viewDemoClose1("show7")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
         <Col sm={6} md={4} xl={3} className="mg-t-20">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("show8")}>slide-Left</Link>
             <Rodal onClose={hide} visible={animation8} animation='slideLeft' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("show8"); }}><i className='fe fe-x ms-auto'></i></span></Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. 
                     The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, 
                     content here', making it look like readable English.
                </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button variant="secondary" onClick={() => viewDemoClose1("show8")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
         <Col sm={6} md={4} xl={3} className="mg-t-20">
             <Link to="#" className="modal-effect btn btn-primary d-grid mb-3" onClick={() => viewDemoShow1("show9")}>slide-Right</Link>
             <Rodal onClose={hide} visible={animation9} animation='slideRight' height={330}>
                 <h6 className='modal-header'>Message Preview
                     <Link to='#'><span className="d-flex ms-auto text-dark" onClick={() => { viewDemoClose1("show9"); }}><i className='fe fe-x ms-auto'></i></span></Link>
                 </h6>
                 <div className='modal-body'>
                     <h6>Why We Use Electoral College, Not Popular Vote</h6>
                     It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of 
                    using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', 
                    making it look like readable English.
                </div>
                 <div className='modal-footer'>
                     <Button className="me-2" variant="primary">Save Changes</Button>
                     <Button variant="secondary" onClick={() => viewDemoClose1("show9")}>Close</Button>
                 </div>
             </Rodal>
         </Col>
      </Row>
    </Fragment>
  );
};

export default Modalsclose;
`

export const modal13 = `<Button 
  variant='' type="button" 
  className="btn-close px-0" aria-label="Close">
</Button>`

export const modal14 = `<Button variant='' 
 type="button"
 className="btn-close" 
 disabled aria-label="Close">
</Button>`

export const modal15 = `<Button variant=''
 type="button" 
 className="btn-close" 
 disabled aria-label="Close">
</Button>`

export const offcanvas1 = `const Offcanva = () => {
  const [offcanvas, setOffcanvas] = useState({});
  const handleOffcanvasOpen = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: true }));
  };
  const handleOffcanvasClose = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: false }));
  };
  return (
    <Fragment>
    <Button variant='primary' className="btn mb-1 me-1" href="#offcanvasExample" onClick={() => handleOffcanvasOpen('liveOffcanvas')}
    role="button" aria-controls="offcanvasExample">
    Link with href
</Button>
<Button variant='primary' className="btn mb-1" type="button" onClick={() => handleOffcanvasOpen('liveOffcanvas')}>
    Button with data-bs-target
</Button>
<Offcanvas show={offcanvas['liveOffcanvas'] || false} onHide={() => handleOffcanvasClose('liveOffcanvas')} backdrop={true} className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasExample">
    <Offcanvas.Header closeButton className="border-bottom border-block-end-dashed">
        <h5 className="offcanvas-title" id="offcanvasExampleLabel">Notifications</h5>
    </Offcanvas.Header>
    <Offcanvas.Body className="p-0">
        <div>
            <ul className="list-group list-group-flush mb-0">
                <li className="list-group-item">
                    <div className="d-flex">
                        <div className="avatar avatar-md avatar-rounded me-3">
                            <img src={face15} alt="" />
                        </div>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Simon Cowall
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 8923
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <div className="avatar avatar-md avatar-rounded me-3">
                            <img src={face14} alt="" />
                        </div>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Adwar Kohali
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 8913
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <span className="avatar avatar-lg bg-info-transparent avatar-rounded me-3">
                            AJ
                        </span>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Aliza John
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 9013
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <div className="avatar avatar-md avatar-rounded me-3">
                            <img src={face13} alt="" />
                        </div>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Aliza John
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 9013
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <div className="avatar avatar-md avatar-rounded me-3">
                            <img src={face12} alt="" />
                        </div>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Ulda Shara
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 02113
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <span className="avatar avatar-lg bg-warning-transparent avatar-rounded me-3">
                            AM
                        </span>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Abrem Moses
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 02876
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <div className="avatar avatar-md avatar-rounded me-3">
                            <img src={face10} alt="" />
                        </div>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Elira Voreme
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 02456
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <div className="avatar avatar-md avatar-rounded me-3">
                            <img src={face9} alt="" />
                        </div>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Aposel Somes
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 65432
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <span className="avatar avatar-lg bg-pink-transparent avatar-rounded me-3">
                            RO
                        </span>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Rubek Onoke
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 873 5613
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <div className="avatar avatar-md avatar-rounded me-3">
                            <img src={face2} alt="" />
                        </div>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Shara Alisab
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 76554 02456
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="d-flex">
                        <div className="avatar avatar-md avatar-rounded me-3">
                            <img src={face4} alt="" />
                        </div>
                        <div className="flex-1  flex-between">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Yakebeth Jone
                                </h6>
                                <p className="fw-semibold fs-11 mb-0 text-muted">
                                    +1(555) 76554 02876
                                </p>
                            </div>
                            <div className="d-flex align-items-center">
                                <Link to="#" className="text-danger me-2"><i className="bi bi-heart-fill"></i></Link>
                                <Dropdown>
                                    <Dropdown.Toggle as="button" className="btn btn-sm btn-icon btn-light btn-wave no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="ri-more-2-fill"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu as="ul">
                                        <li><Dropdown.Item as="a"><i className="ri-share-line me-2 align-middle d-inline-block"></i>Share</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-phone-line me-2 align-middle d-inline-block"></i>Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-chat-2-line me-2 align-middle d-inline-block"></i>Message</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-video-chat-line me-2 align-middle d-inline-block"></i>Video Call</Dropdown.Item></li>
                                        <li><Dropdown.Item as="a"><i className="ri-delete-bin-5-line me-2 align-middle d-inline-block"></i>Delete</Dropdown.Item></li>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </Offcanvas.Body>
</Offcanvas>
    </Fragment>
  );
};

export default Offcanva;`

export const offcanvas2 = `const Offcanva = () => {
  const [offcanvas, setOffcanvas] = useState({});
  const handleOffcanvasOpen = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: true }));
  };
  const handleOffcanvasClose = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: false }));
  };
  return (
    <Fragment>
      <Button variant='primary' 
       className="btn" type="button" 
       onClick={handleShow1}>
       Enable body scrolling
      </Button>
      <Offcanvas show={show1} 
       onHide={handleClose1} 
       className="offcanvas offcanvas-start" 
       data-bs-scroll="true" 
       backdrop={false}
          tabIndex={-1} id="offcanvasScrolling">
          <Offcanvas.Header closeButton 
           className="border-bottom border-block-end-dashed">
              <h5 className="offcanvas-title"
               id="offcanvasScrollingLabel">Notifications</h5>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-0">
                <div>
                  <ul className="list-group 
                    list-group-flush mb-0">
                      <li className="list-group-item">
                          <div className="d-flex 
                            align-items-center">
                              <div className="me-2">
                                  <span className="avatar 
                                    avatar-md bg-primary 
                                    avatar-rounded">
                                      NW
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p className="fw-semibold 
                                   mb-0">
                                    New Website Created
                                    <span className="badge 
                                     bg-light 
                                     text-muted float-end">
                                      20 Nov 2022
                                    </span>
                                  </p>
                                  <span className="fs-12 
                                   text-muted">
                                   <i className="ri-time-line
                                     align-middle 
                                     me-1 d-inline-block">
                                     </i>30 mins ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                            align-items-center">
                              <div className="me-2">
                                  <span className="avatar 
                                   avatar-md bg-danger 
                                    avatar-rounded">
                                      CH
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p className="fw-semibold 
                                   mb-0">
                                  Prepare for the new project
                                     <span className="badge 
                                       bg-light 
                                       text-muted float-end">
                                       3 Jan 2023
                                     </span>
                                  </p>
                                  <span className="fs-12 
                                   text-muted">
                                   <i className="ri-time-line 
                                   align-middle me-1 
                                   d-inline-block">
                                   </i>2 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex
                            align-items-center">
                              <div className="me-2">
                                  <span className="avatar 
                                   avatar-md bg-info 
                                    avatar-rounded">
                                      S
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p className="fw-semibold 
                                  mb-0">
                                   Decide the live discussion
                                  <span className="badge 
                                  bg-light 
                                  text-muted float-end">
                                   17 Feb 2023
                                  </span>
                                  </p>
                                  <span className="fs-12 
                                   text-muted">
                                   <i className="ri-time-line 
                                   align-middle
                                     me-1 d-inline-block"></i>
                                     3 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                           align-items-center">
                              <div className="me-2">
                                  <span className="avatar
                                     avatar-md 
                                     avatar-rounded">
                                      <img src={face12} 
                                       alt="" />
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p className="fw-semibold 
                                   mb-0">
                                     Meeting at 3:00 pm
                                      <span 
                                        className="badge 
                                         bg-light 
                                         text-muted 
                                        float-end">
                                           29 Dec 2022
                                      </span>
                                  </p>
                                  <span 
                                     className="fs-12 
                                      text-muted">
                                        <i 
                                        className="ri-time-
                                         line
                                          align-middle 
                                          me-1 
                                          d-inline-block">
                                          </i>4 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                           align-items-center">
                              <div className="me-2">
                                  <span 
                                  className="avatar 
                                  avatar-md bg-success 
                                   avatar-rounded">
                                      RC
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p className="fw-semibold 
                                   mb-0">
                                    Prepare for presentation
                                    <span 
                                     className="badge 
                                     bg-light text-muted 
                                     float-end">
                                      31 Dec 2022
                                    </span><
                                  /p>
                                  <span 
                                   className="fs-12 
                                    text-muted">
                                    <i className="ri-time-line 
                                     align-middle 
                                     me-1 
                                     d-inline-block">
                                     </i>4 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                           align-items-center">
                              <div className="me-2">
                                  <span className="avatar 
                                   avatar-md 
                                   avatar-rounded">
                                      <img src={face1} 
                                      alt="" />
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p className="fw-semibold
                                    mb-0">
                                    Brenda New product 
                                    launching
                                    <span className="badge 
                                    bg-light text-muted 
                                    float-end">
                                     1 Jan 2023
                                     </span>
                                   </p>
                                  <span 
                                   className="fs-12 
                                    text-muted">
                                     <i className="ri-
                                      time-line
                                       align-middle me-1 
                                       d-inline-block"></i>
                                       7 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                           align-items-center">
                              <div className="me-2">
                                  <span className="avatar
                                   avatar-md bg-secondary 
                                   avatar-rounded">
                                      M
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p className="fw-semibold 
                                   mb-0">
                                  Medeleine Hey! there i'm 
                                  available
                                  <span className="badge 
                                  bg-light
                                    text-muted float-end">
                                    5 Jan 2023
                                  </span></p>
                                  <span 
                                   className="fs-12 
                                   text-muted">
                                   <i className="ri-time-line 
                                    align-middle me-1 
                                    d-inline-block"></i>
                                    3 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li 
                       className="list-group-item">
                          <div className="d-flex
                            align-items-center">
                              <div className="me-2">
                                  <span 
                                   className="avatar 
                                   avatar-md bg-info 
                                   avatar-rounded">
                                      OL
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p 
                                   className="fw-semibold 
                                   mb-0">
                                    Olivia New schedule 
                                    release
                                    <span className="badge 
                                     bg-light text-muted 
                                      float-end">
                                       6 Jan 2023
                                    </span>
                                  </p>
                                  <span 
                                   className="fs-12 
                                   text-muted">
                                   <i className="ri-time-line 
                                    align-middle me-1 
                                    d-inline-block">
                                    </i>45 mins ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                            align-items-center">
                              <div className="me-2">
                                  <span className="avatar 
                                   avatar-md bg-warning 
                                   avatar-rounded">
                                      A
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p className="fw-semibold
                                    mb-0">
                                    Kamala Preparing for new 
                                    admin launch
                                    <span className="badge 
                                    bg-light text-muted 
                                    float-end">
                                    7 Jan 2023
                                    </span>
                                  </p>
                                  <span 
                                   className="fs-12 
                                    text-muted">
                                    <i className="ri-time-line
                                     align-middle me-1 
                                     d-inline-block">
                                     </i>28 mins ago</span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex
                           align-items-center">
                              <div className="me-2">
                                  <span className="avatar 
                                   avatar-md avatar-rounded">
                                      <img src={face6} 
                                      alt="" />
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p 
                                   className="fw-semibold
                                     mb-0">
                                     Oisha Meeting with 
                                     clinet for dinner
                                     <span className="badge 
                                       bg-light text-muted 
                                       float-end">
                                       10 Jan 2023
                                     </span>
                                  </p>
                                  <span 
                                   className="fs-12 
                                    text-muted">
                                   <i className="ri-time-line
                                     align-middle 
                                      me-1 d-inline-block">
                                      </i>
                                      14 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                           align-items-center">
                              <div className="me-2">
                                  <span className="avatar
                                   avatar-md bg-danger 
                                   avatar-rounded">
                                      CH
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p 
                                   className="fw-semibold
                                    mb-0">Prepare for the new 
                                    project
                                    <span 
                                      className="badge 
                                      bg-light text-muted 
                                      float-end">
                                       3 Jan 2023
                                    </span>
                                  </p>
                                  <span className="fs-12 
                                   text-muted">
                                   <i className="ri-time-line 
                                    align-middle me-1 
                                    d-inline-block">
                                    </i>2 hrs ago<
                                  /span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                           align-items-center">
                              <div className="me-2">
                                  <span className="avatar 
                                   avatar-md bg-info 
                                   avatar-rounded">
                                      S
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p 
                                   className="fw-semibold
                                    mb-0">Decide the live 
                                     discussion
                                    <span 
                                      className="badge 
                                       bg-light
                                      text-muted 
                                      float-end">
                                      17 Feb 2023
                                    </span>
                                  </p>
                                  <span
                                   className="fs-12 
                                   text-muted">
                                   <i className="ri-time-line 
                                   align-middle me-1 
                                   d-inline-block"></i>
                                   3 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex 
                           align-items-center">
                              <div className="me-2">
                                  <span className="avatar
                                   avatar-md avatar-rounded">
                                      <img src={face14}
                                       alt="" />
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p 
                                   className="fw-semibold
                                     mb-0">
                                     Meeting at 3:00 pm
                                     <span 
                                      className="badge
                                       bg-light 
                                       text-muted 
                                       float-end">
                                       29 Dec 2022
                                      </span>
                                  </p>
                                  <span 
                                   className="fs-12 
                                    text-muted">
                                    <i className="ri-time-line 
                                    align-middle 
                                    me-1 
                                    d-inline-block"></i>
                                    4 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                      <li className="list-group-item">
                          <div className="d-flex
                            align-items-center">
                              <div className="me-2">
                                  <span className="avatar
                                    avatar-md 
                                    bg-success 
                                    avatar-rounded">
                                      RC
                                  </span>
                              </div>
                              <div className="flex-fill">
                                  <p 
                                   className="fw-semibold 
                                   mb-0">
                                    Prepare for presentation
                                    <span className="badge 
                                     bg-light text-muted 
                                     float-end">
                                     31 Dec 2022
                                    </span>
                                  </p>
                                  <span 
                                   className="fs-12 
                                   text-muted">
                                   <i className="ri-time-line 
                                    align-middle 
                                    me-1
                                    d-inline-block">
                                    </i>
                                    4 hrs ago
                                  </span>
                              </div>
                          </div>
                      </li>
                  </ul>
              </div>
          </Offcanvas.Body>
      </Offcanvas>
    </Fragment>
  );
};

export default Offcanva;`

export const offcanvas3 = `const Offcanva = () => {
  const [offcanvas, setOffcanvas] = useState({});
  const handleOffcanvasOpen = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: true }));
  };
  const handleOffcanvasClose = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: false }));
  };
  return (
    <Fragment>
      <Button 
       className="btn btn-primary" 
       type="button" data-bs-toggle="offcanvas" 
       onClick={handleShow2}
          data-bs-target="#staticBackdrop" 
          aria-controls="staticBackdrop">
          Toggle static offcanvas
      </Button>
      <Offcanvas show={show2} 
       onHide={handleClose2} backdrop="static" 
       className="offcanvas offcanvas-start" tabIndex={-1}
          id="staticBackdrop" >
          <Offcanvas.Header closeButton 
            className="offcanvas-header border-bottom 
             border-block-end-dashed">
              <h5 className="offcanvas-title" 
               id="staticBackdropLabel">
                Notifications
              </h5>
          </Offcanvas.Header>
          <Offcanvas.Body className="offcanvas-body p-0">
            <div>
              <ul className="list-group 
                list-group-flush mb-0">
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                                avatar-md bg-primary 
                                avatar-rounded">
                                  NW
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                New Website Created
                                <span className="badge 
                                 bg-light 
                                 text-muted float-end">
                                  20 Nov 2022
                                </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line
                                 align-middle 
                                 me-1 d-inline-block">
                                 </i>30 mins ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-danger 
                                avatar-rounded">
                                  CH
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                              Prepare for the new project
                                 <span className="badge 
                                   bg-light 
                                   text-muted float-end">
                                   3 Jan 2023
                                 </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle me-1 
                               d-inline-block">
                               </i>2 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-info 
                                avatar-rounded">
                                  S
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                              mb-0">
                               Decide the live discussion
                              <span className="badge 
                              bg-light 
                              text-muted float-end">
                               17 Feb 2023
                              </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle
                                 me-1 d-inline-block"></i>
                                 3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                                 avatar-md 
                                 avatar-rounded">
                                  <img src={face12} 
                                   alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                 Meeting at 3:00 pm
                                  <span 
                                    className="badge 
                                     bg-light 
                                     text-muted 
                                    float-end">
                                       29 Dec 2022
                                  </span>
                              </p>
                              <span 
                                 className="fs-12 
                                  text-muted">
                                    <i 
                                    className="ri-time-
                                     line
                                      align-middle 
                                      me-1 
                                      d-inline-block">
                                      </i>4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span 
                              className="avatar 
                              avatar-md bg-success 
                               avatar-rounded">
                                  RC
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                Prepare for presentation
                                <span 
                                 className="badge 
                                 bg-light text-muted 
                                 float-end">
                                  31 Dec 2022
                                </span><
                              /p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line 
                                 align-middle 
                                 me-1 
                                 d-inline-block">
                                 </i>4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md 
                               avatar-rounded">
                                  <img src={face1} 
                                  alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold
                                mb-0">
                                Brenda New product 
                                launching
                                <span className="badge 
                                bg-light text-muted 
                                float-end">
                                 1 Jan 2023
                                 </span>
                               </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                 <i className="ri-
                                  time-line
                                   align-middle me-1 
                                   d-inline-block"></i>
                                   7 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md bg-secondary 
                               avatar-rounded">
                                  M
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                              Medeleine Hey! there i'm 
                              available
                              <span className="badge 
                              bg-light
                                text-muted float-end">
                                5 Jan 2023
                              </span></p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block"></i>
                                3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li 
                   className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span 
                               className="avatar 
                               avatar-md bg-info 
                               avatar-rounded">
                                  OL
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold 
                               mb-0">
                                Olivia New schedule 
                                release
                                <span className="badge 
                                 bg-light text-muted 
                                  float-end">
                                   6 Jan 2023
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block">
                                </i>45 mins ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-warning 
                               avatar-rounded">
                                  A
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold
                                mb-0">
                                Kamala Preparing for new 
                                admin launch
                                <span className="badge 
                                bg-light text-muted 
                                float-end">
                                7 Jan 2023
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line
                                 align-middle me-1 
                                 d-inline-block">
                                 </i>28 mins ago</span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md avatar-rounded">
                                  <img src={face6} 
                                  alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                 mb-0">
                                 Oisha Meeting with 
                                 clinet for dinner
                                 <span className="badge 
                                   bg-light text-muted 
                                   float-end">
                                   10 Jan 2023
                                 </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                               <i className="ri-time-line
                                 align-middle 
                                  me-1 d-inline-block">
                                  </i>
                                  14 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md bg-danger 
                               avatar-rounded">
                                  CH
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                mb-0">Prepare for the new 
                                project
                                <span 
                                  className="badge 
                                  bg-light text-muted 
                                  float-end">
                                   3 Jan 2023
                                </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block">
                                </i>2 hrs ago<
                              /span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-info 
                               avatar-rounded">
                                  S
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                mb-0">Decide the live 
                                 discussion
                                <span 
                                  className="badge 
                                   bg-light
                                  text-muted 
                                  float-end">
                                  17 Feb 2023
                                </span>
                              </p>
                              <span
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle me-1 
                               d-inline-block"></i>
                               3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md avatar-rounded">
                                  <img src={face14}
                                   alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                 mb-0">
                                 Meeting at 3:00 pm
                                 <span 
                                  className="badge
                                   bg-light 
                                   text-muted 
                                   float-end">
                                   29 Dec 2022
                                  </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line 
                                align-middle 
                                me-1 
                                d-inline-block"></i>
                                4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar
                                avatar-md 
                                bg-success 
                                avatar-rounded">
                                  RC
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold 
                               mb-0">
                                Prepare for presentation
                                <span className="badge 
                                 bg-light text-muted 
                                 float-end">
                                 31 Dec 2022
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle 
                                me-1
                                d-inline-block">
                                </i>
                                4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
              </ul>
            </div>
          </Offcanvas.Body>
      </Offcanvas>
    </Fragment>
  );
};

export default Offcanva;`

export const offcanvas4 = `const Offcanva = () => {
  const [offcanvas, setOffcanvas] = useState({});
  const handleOffcanvasOpen = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: true }));
  };
  const handleOffcanvasClose = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: false }));
  };
  return (
    <Fragment>
       <Button className="btn btn-primary" 
        type="button" onClick={handleShow3}>
         Enable both scrolling &amp;
           backdrop
       </Button>
       <Offcanvas show={show3} onHide={handleClose3}
         backdrop={true} className="offcanvas offcanvas-start" 
          tabIndex={-1}
           id="offcanvasWithBothOptions" 
            aria-labelledby="offcanvasWithBothOptionsLabel">
           <Offcanvas.Header closeButton className="border-bottom border-block-end-dashed">
               <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel">Notifications</h5>
           </Offcanvas.Header>
           <Offcanvas.Body className="p-0">
            <div>
              <ul className="list-group 
                list-group-flush mb-0">
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                                avatar-md bg-primary 
                                avatar-rounded">
                                  NW
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                New Website Created
                                <span className="badge 
                                 bg-light 
                                 text-muted float-end">
                                  20 Nov 2022
                                </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line
                                 align-middle 
                                 me-1 d-inline-block">
                                 </i>30 mins ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-danger 
                                avatar-rounded">
                                  CH
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                              Prepare for the new project
                                 <span className="badge 
                                   bg-light 
                                   text-muted float-end">
                                   3 Jan 2023
                                 </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle me-1 
                               d-inline-block">
                               </i>2 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-info 
                                avatar-rounded">
                                  S
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                              mb-0">
                               Decide the live discussion
                              <span className="badge 
                              bg-light 
                              text-muted float-end">
                               17 Feb 2023
                              </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle
                                 me-1 d-inline-block"></i>
                                 3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                                 avatar-md 
                                 avatar-rounded">
                                  <img src={face12} 
                                   alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                 Meeting at 3:00 pm
                                  <span 
                                    className="badge 
                                     bg-light 
                                     text-muted 
                                    float-end">
                                       29 Dec 2022
                                  </span>
                              </p>
                              <span 
                                 className="fs-12 
                                  text-muted">
                                    <i 
                                    className="ri-time-
                                     line
                                      align-middle 
                                      me-1 
                                      d-inline-block">
                                      </i>4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span 
                              className="avatar 
                              avatar-md bg-success 
                               avatar-rounded">
                                  RC
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                Prepare for presentation
                                <span 
                                 className="badge 
                                 bg-light text-muted 
                                 float-end">
                                  31 Dec 2022
                                </span><
                              /p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line 
                                 align-middle 
                                 me-1 
                                 d-inline-block">
                                 </i>4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md 
                               avatar-rounded">
                                  <img src={face1} 
                                  alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold
                                mb-0">
                                Brenda New product 
                                launching
                                <span className="badge 
                                bg-light text-muted 
                                float-end">
                                 1 Jan 2023
                                 </span>
                               </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                 <i className="ri-
                                  time-line
                                   align-middle me-1 
                                   d-inline-block"></i>
                                   7 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md bg-secondary 
                               avatar-rounded">
                                  M
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                              Medeleine Hey! there i'm 
                              available
                              <span className="badge 
                              bg-light
                                text-muted float-end">
                                5 Jan 2023
                              </span></p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block"></i>
                                3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li 
                   className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span 
                               className="avatar 
                               avatar-md bg-info 
                               avatar-rounded">
                                  OL
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold 
                               mb-0">
                                Olivia New schedule 
                                release
                                <span className="badge 
                                 bg-light text-muted 
                                  float-end">
                                   6 Jan 2023
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block">
                                </i>45 mins ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-warning 
                               avatar-rounded">
                                  A
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold
                                mb-0">
                                Kamala Preparing for new 
                                admin launch
                                <span className="badge 
                                bg-light text-muted 
                                float-end">
                                7 Jan 2023
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line
                                 align-middle me-1 
                                 d-inline-block">
                                 </i>28 mins ago</span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md avatar-rounded">
                                  <img src={face6} 
                                  alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                 mb-0">
                                 Oisha Meeting with 
                                 clinet for dinner
                                 <span className="badge 
                                   bg-light text-muted 
                                   float-end">
                                   10 Jan 2023
                                 </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                               <i className="ri-time-line
                                 align-middle 
                                  me-1 d-inline-block">
                                  </i>
                                  14 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md bg-danger 
                               avatar-rounded">
                                  CH
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                mb-0">Prepare for the new 
                                project
                                <span 
                                  className="badge 
                                  bg-light text-muted 
                                  float-end">
                                   3 Jan 2023
                                </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block">
                                </i>2 hrs ago<
                              /span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-info 
                               avatar-rounded">
                                  S
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                mb-0">Decide the live 
                                 discussion
                                <span 
                                  className="badge 
                                   bg-light
                                  text-muted 
                                  float-end">
                                  17 Feb 2023
                                </span>
                              </p>
                              <span
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle me-1 
                               d-inline-block"></i>
                               3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md avatar-rounded">
                                  <img src={face14}
                                   alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                 mb-0">
                                 Meeting at 3:00 pm
                                 <span 
                                  className="badge
                                   bg-light 
                                   text-muted 
                                   float-end">
                                   29 Dec 2022
                                  </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line 
                                align-middle 
                                me-1 
                                d-inline-block"></i>
                                4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar
                                avatar-md 
                                bg-success 
                                avatar-rounded">
                                  RC
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold 
                               mb-0">
                                Prepare for presentation
                                <span className="badge 
                                 bg-light text-muted 
                                 float-end">
                                 31 Dec 2022
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle 
                                me-1
                                d-inline-block">
                                </i>
                                4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
              </ul>
            </div>
           </Offcanvas.Body>
       </Offcanvas>
    </Fragment>
  );
};

export default Offcanva;`

export const offcanvas5 = `const Offcanva = () => {
  const [offcanvas, setOffcanvas] = useState({});
  const handleOffcanvasOpen = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: true }));
  };
  const handleOffcanvasClose = (offcanvasName) => {
      setOffcanvas((prevOffcanvas) => ({ ...prevOffcanvas, [offcanvasName]: false }));
  };
  return (
    <Fragment>
       <Button className="btn btn-primary mb-1 me-1" type="button" data-bs-toggle="offcanvas" 
       onClick={handleShowt}
           data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">Toggle top
           offcanvas</Button>
       <Offcanvas placement='top' show={showt} onHide={handleCloset} className="offcanvas 
       offcanvas-top" tabIndex={-1} id="offcanvasTop"
           aria-labelledby="offcanvasTopLabel">
           <Offcanvas.Header closeButton className="offcanvas-header">
               <h5 className="offcanvas-title" id="offcanvasTopLabel">Offcanvas top</h5>
           </Offcanvas.Header>
           <Offcanvas.Body>
               ...
           </Offcanvas.Body>
       </Offcanvas>
       <Button className="btn btn-primary mb-1 me-1" type="button" data-bs-toggle="offcanvas" 
        onClick={handleShowr}
           data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Toggle right
           offcanvas
       </Button>
       <Offcanvas placement='end' show={showr} onHide={handleCloser} className="offcanvas 
        offcanvas-end" 
        tabIndex={-1} id="offcanvasRight"
           aria-labelledby="offcanvasRightLabel1">
           <Offcanvas.Header closeButton className="offcanvas-header border-bottom 
            border-block-end-dashed">
               <h5 className="offcanvas-title" id="offcanvasRightLabel1">Notifications
               </h5>
           </Offcanvas.Header>
           <Offcanvas.Body className="p-0">
             <div>
              <ul className="list-group 
                list-group-flush mb-0">
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                                avatar-md bg-primary 
                                avatar-rounded">
                                  NW
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                New Website Created
                                <span className="badge 
                                 bg-light 
                                 text-muted float-end">
                                  20 Nov 2022
                                </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line
                                 align-middle 
                                 me-1 d-inline-block">
                                 </i>30 mins ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-danger 
                                avatar-rounded">
                                  CH
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                              Prepare for the new project
                                 <span className="badge 
                                   bg-light 
                                   text-muted float-end">
                                   3 Jan 2023
                                 </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle me-1 
                               d-inline-block">
                               </i>2 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-info 
                                avatar-rounded">
                                  S
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                              mb-0">
                               Decide the live discussion
                              <span className="badge 
                              bg-light 
                              text-muted float-end">
                               17 Feb 2023
                              </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle
                                 me-1 d-inline-block"></i>
                                 3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                                 avatar-md 
                                 avatar-rounded">
                                  <img src={face12} 
                                   alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                 Meeting at 3:00 pm
                                  <span 
                                    className="badge 
                                     bg-light 
                                     text-muted 
                                    float-end">
                                       29 Dec 2022
                                  </span>
                              </p>
                              <span 
                                 className="fs-12 
                                  text-muted">
                                    <i 
                                    className="ri-time-
                                     line
                                      align-middle 
                                      me-1 
                                      d-inline-block">
                                      </i>4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span 
                              className="avatar 
                              avatar-md bg-success 
                               avatar-rounded">
                                  RC
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                                Prepare for presentation
                                <span 
                                 className="badge 
                                 bg-light text-muted 
                                 float-end">
                                  31 Dec 2022
                                </span><
                              /p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line 
                                 align-middle 
                                 me-1 
                                 d-inline-block">
                                 </i>4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md 
                               avatar-rounded">
                                  <img src={face1} 
                                  alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold
                                mb-0">
                                Brenda New product 
                                launching
                                <span className="badge 
                                bg-light text-muted 
                                float-end">
                                 1 Jan 2023
                                 </span>
                               </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                 <i className="ri-
                                  time-line
                                   align-middle me-1 
                                   d-inline-block"></i>
                                   7 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md bg-secondary 
                               avatar-rounded">
                                  M
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold 
                               mb-0">
                              Medeleine Hey! there i'm 
                              available
                              <span className="badge 
                              bg-light
                                text-muted float-end">
                                5 Jan 2023
                              </span></p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block"></i>
                                3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li 
                   className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span 
                               className="avatar 
                               avatar-md bg-info 
                               avatar-rounded">
                                  OL
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold 
                               mb-0">
                                Olivia New schedule 
                                release
                                <span className="badge 
                                 bg-light text-muted 
                                  float-end">
                                   6 Jan 2023
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block">
                                </i>45 mins ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-warning 
                               avatar-rounded">
                                  A
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p className="fw-semibold
                                mb-0">
                                Kamala Preparing for new 
                                admin launch
                                <span className="badge 
                                bg-light text-muted 
                                float-end">
                                7 Jan 2023
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line
                                 align-middle me-1 
                                 d-inline-block">
                                 </i>28 mins ago</span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md avatar-rounded">
                                  <img src={face6} 
                                  alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                 mb-0">
                                 Oisha Meeting with 
                                 clinet for dinner
                                 <span className="badge 
                                   bg-light text-muted 
                                   float-end">
                                   10 Jan 2023
                                 </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                               <i className="ri-time-line
                                 align-middle 
                                  me-1 d-inline-block">
                                  </i>
                                  14 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md bg-danger 
                               avatar-rounded">
                                  CH
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                mb-0">Prepare for the new 
                                project
                                <span 
                                  className="badge 
                                  bg-light text-muted 
                                  float-end">
                                   3 Jan 2023
                                </span>
                              </p>
                              <span className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle me-1 
                                d-inline-block">
                                </i>2 hrs ago<
                              /span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar 
                               avatar-md bg-info 
                               avatar-rounded">
                                  S
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                mb-0">Decide the live 
                                 discussion
                                <span 
                                  className="badge 
                                   bg-light
                                  text-muted 
                                  float-end">
                                  17 Feb 2023
                                </span>
                              </p>
                              <span
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                               align-middle me-1 
                               d-inline-block"></i>
                               3 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex 
                       align-items-center">
                          <div className="me-2">
                              <span className="avatar
                               avatar-md avatar-rounded">
                                  <img src={face14}
                                   alt="" />
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold
                                 mb-0">
                                 Meeting at 3:00 pm
                                 <span 
                                  className="badge
                                   bg-light 
                                   text-muted 
                                   float-end">
                                   29 Dec 2022
                                  </span>
                              </p>
                              <span 
                               className="fs-12 
                                text-muted">
                                <i className="ri-time-line 
                                align-middle 
                                me-1 
                                d-inline-block"></i>
                                4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
                  <li className="list-group-item">
                      <div className="d-flex
                        align-items-center">
                          <div className="me-2">
                              <span className="avatar
                                avatar-md 
                                bg-success 
                                avatar-rounded">
                                  RC
                              </span>
                          </div>
                          <div className="flex-fill">
                              <p 
                               className="fw-semibold 
                               mb-0">
                                Prepare for presentation
                                <span className="badge 
                                 bg-light text-muted 
                                 float-end">
                                 31 Dec 2022
                                </span>
                              </p>
                              <span 
                               className="fs-12 
                               text-muted">
                               <i className="ri-time-line 
                                align-middle 
                                me-1
                                d-inline-block">
                                </i>
                                4 hrs ago
                              </span>
                          </div>
                      </div>
                  </li>
              </ul>
            </div>
           </Offcanvas.Body>
        </Offcanvas>
        <Button className="btn btn-primary mb-1" type="button" data-bs-toggle="offcanvas" 
         onClick={handleShowb}
            data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom">Toggle
            bottom
            offcanvas</Button>
        <Offcanvas placement='bottom' show={showb} onHide={handleCloseb} className="offcanvas 
         offcanvas-bottom" tabIndex={-1} id="offcanvasBottom"
            aria-labelledby="offcanvasBottomLabel">
            <Offcanvas.Header closeButton className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasBottomLabel">Offcanvas bottom
                </h5>
            </Offcanvas.Header>
            <Offcanvas.Body className="offcanvas-body small">
                ...
            </Offcanvas.Body>
        </Offcanvas>
    </Fragment>
  );
};

export default Offcanva;`

export const placeholder1 = ` <p className="placeholder-glow mb-0">
    <span className="placeholder col-12"></span>
</p>
<p className="placeholder-wave mb-0">
    <span className="placeholder col-12"></span>
</p>`

export const placeholder2 = `<span className="placeholder col-12 placeholder-xl mb-1"></span>
<span className="placeholder col-12 placeholder-lg"></span>
<span className="placeholder col-12"></span>
<span className="placeholder col-12 placeholder-sm"></span>
<span className="placeholder col-12 placeholder-xs"></span>`

export const placeholder3 = `<span className="placeholder col-12"></span>
<span className="placeholder col-12 bg-primary"></span>
<span className="placeholder col-12 bg-secondary"></span>
<span className="placeholder col-12 bg-success"></span>
<span className="placeholder col-12 bg-danger"></span>
<span className="placeholder col-12 bg-warning"></span>
<span className="placeholder col-12 bg-info"></span>
<span className="placeholder col-12 bg-light"></span>
<span className="placeholder col-12 bg-dark"></span>`

export const placeholder4 = `<span className="placeholder bg-primary col-6"></span>
<span className="placeholder bg-primary w-75"></span>
<span className="placeholder bg-primary" style={{ width: 25 }}></span>`